import styled from 'styled-components';

export const CustomMonthPickerWrapper = styled.div`

.react-datepicker-wrapper{
  width: 100%;
}
/* Styles for .react-datepicker */
.react-datepicker{
  border: none;
  box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;
}
  /* Styles for .react-datepicker__header */
  .react-datepicker__header {
    background-color: #eef0f8;
    border-color: #e8e8e8;
  }

  /* Styles for .react-datepicker__month-wrapper */
  .react-datepicker__month-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  /* Styles for .react-datepicker__month .react-datepicker__month-text */
  .react-datepicker__month .react-datepicker__month-text {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 3rem;
  }

  /* Styles for .react-datepicker__month-text--keyboard-selected:hover */
  .react-datepicker__month-text--keyboard-selected:hover {
    color: #fff;
    background-color: #258ea6;
  }
`